import { AgentInSinglePaymentProviderContext } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { AddOrEditAgentInSinglePaymentProviderContextForm } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/components/AddOrEditAgentInSinglePaymentProviderCredentials/components/AddOrEditAgentInSinglePaymentProviderContextForm';
import { useAddOrEditAgentInSinglePaymentProviderContext } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/hooks/useAddOrEditAgentInSinglePaymentProviderContext';
import {
  AddAgentInSinglePaymentProviderContextCredentialsFormSchema,
  AddAgentInSinglePaymentProviderContextCredentialsFormType,
} from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/schemas/AddAgentInSinglePaymentProviderContextCredentialsForm.schema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
interface AddOrEditAgentInSinglePaymentProviderCredentialsDialogProps {
  agentId: string;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  selectedAgentInSinglePaymentProviderContext?: AgentInSinglePaymentProviderContext;
}
export const AddOrEditAgentInSinglePaymentProviderCredentialsDialog = ({
  agentId,
  opened,
  setOpened,
  toggleDialog,
  selectedAgentInSinglePaymentProviderContext,
}: AddOrEditAgentInSinglePaymentProviderCredentialsDialogProps) => {
  const { createOrUpdateAgentInSinglePaymentProviderContext, loading } =
    useAddOrEditAgentInSinglePaymentProviderContext({
      agentId,
      selectedAgentInSinglePaymentProviderContext,
    });
  const onSubmit = async (formValues: AddAgentInSinglePaymentProviderContextCredentialsFormType) => {
    await createOrUpdateAgentInSinglePaymentProviderContext(formValues);
    toggleDialog();
  };
  const editAgentInSinglePaymentProviderCredentialsDefaultValues = selectedAgentInSinglePaymentProviderContext
    ? {
        paymentMethodType: selectedAgentInSinglePaymentProviderContext.paymentMethodType,
        providerId: selectedAgentInSinglePaymentProviderContext.providerId,
        agentId: selectedAgentInSinglePaymentProviderContext.agentId,
        configuration: !!selectedAgentInSinglePaymentProviderContext.configuration?.productId,
        productId: selectedAgentInSinglePaymentProviderContext.configuration?.productId,
        merchantId: selectedAgentInSinglePaymentProviderContext.configuration?.merchantId,
        merchantKey: selectedAgentInSinglePaymentProviderContext.configuration?.merchantKey,
        merchantPassword: selectedAgentInSinglePaymentProviderContext.configuration?.merchantPassword,
      }
    : undefined;
  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      title={selectedAgentInSinglePaymentProviderContext ? 'EDIT_CREDENTIALS' : 'ADD_CREDENTIALS'}
      onSubmitForm={onSubmit}
      isLoading={loading}
      formSchema={AddAgentInSinglePaymentProviderContextCredentialsFormSchema}
      defaultValues={editAgentInSinglePaymentProviderCredentialsDefaultValues}
    >
      <AddOrEditAgentInSinglePaymentProviderContextForm />
    </EditDialogWrapper>
  );
};
